<template>
  <div class="index-group">
    <a :href="trustUrl"><h4 @click="goToTrust">{{ trust.name }}</h4></a>
    <div v-if="concepts.length == 0 && !hasNoConcepts">Fetching concepts...</div>
    <div v-if="hasNoConcepts == true"><i>No concepts</i></div>
    <div class="index-item-list">
      <div class="index-item" v-for="(concept, index) in concepts" :key="index">
        <a :href="conceptUrl(concept)"><p @click="goToConcept(concept)">{{ concept.name }}</p></a>
      </div>
    </div>
  </div>
</template>

<script>
import helpers from '@trust/helpers'

export default {
  name: 'GroupIndex',
  components: {
  },
  data() {
      return {
        concepts: [],
        hasNoConcepts: false
      }
  },
  props: ['trust'],
  computed: {
    trustUrl(){
      return '/' + this.trust.shorthand;
    },
  },
  mounted() {
    this.fetchConcepts();
  },
  methods: {
    conceptUrl(conceptObj){
      let slug = encodeURIComponent(conceptObj.name.toLowerCase());
      return this.trustUrl + '/' + slug;
    },
    goToTrust(){
      // this.$store.dispatch('routing/goToGroupHome', { group: this.trust.shorthand })
    },
    goToConcept(conceptObj){
      console.log(conceptObj )
      // let slug = encodeURIComponent(conceptObj.name.toLowerCase());
      // this.$store.dispatch('routing/goToConcept', { slug }, {root: true});
      // this.$store.dispatch('closeRight');
    },
    async fetchConcepts(){
      try {
        const response = await helpers.callServer('POST', this.trust.shorthand, this.$store.state.org.baseTenantUrl + '/concepts');
        // console.log(response)
        let allConcepts = response.data.concepts;

        // console.log('fetched concepts: ', allConcepts);

        // sort by order
        allConcepts.sort(function(a, b) {
          if (a.order < b.order) return -1;
          if (a.order > b.order) return 1;
          return 0;
        });

        this.concepts = allConcepts;

        if(this.concepts.length == 0){
          this.hasNoConcepts = true;
        }
      } catch (error) { console.log(error) }
    }
  },
}

</script>

<style>
.index-group {
  display: grid;
  grid-template-columns: 1fr 3fr;
  font-size: 14px;
  line-height: 150%;
  border-bottom: 1px solid var(--beige-900);
  padding-bottom: 8px;
}

.index-group h4 {
  margin: 0;
  margin-bottom: 4px;
  font-family: "Untitled Serif";
  font-size: 1rem;
  font-weight: 500;
}

.index-group a {
  text-decoration: none;
  color: var(--beige-1000);
}

.index-group a:hover {
  cursor: pointer;
  color: var(--orange-500);
}

.index-item-list {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-right: 20px;
}

.index-item-list .index-item {
  margin-right: 8px;
}

.index-item {

}

.index-item p {
    margin: 0;
}

@media screen and (max-device-width: 600px){
  .index-group {
    display: flex;
    flex-direction: column;
  }

  .index-item-list {
    display: flex;
    flex-direction: column;
  }
}

</style>
